import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Header.st.css';
import Heading from '../../Heading';
import Text from '../../Text';
import { DataHooks } from './hooks';
import { isString } from '../../utils/StringUtils';

class Header extends React.PureComponent {
  static displayName = 'Card.Header';

  static propTypes = {
    /** Applies a data-hook HTML attribute to be used in the tests */
    dataHook: PropTypes.string,

    /** Sets card title text value. Title can also be overridden to any other component. */
    title: PropTypes.node.isRequired,

    /** Sets card subtitle text value. Subtitle can also be overridden to any other component. */
    subtitle: PropTypes.node,

    /** Adds an empty container on the right side of a header. Used to store action buttons or other components. */
    suffix: PropTypes.node,

    /** Specifies a CSS class name to be appended to the component’s root element. */
    className: PropTypes.string,
  };

  render() {
    const { dataHook, title, subtitle, suffix, className } = this.props;

    return (
      <div data-hook={dataHook} className={st(classes.root, {}, className)}>
        <div className={classes.titleWrapper}>
          {isString(title) ? (
            <Heading
              dataHook={DataHooks.title}
              size="medium"
              children={title}
              className={classes.title}
            />
          ) : (
            <span data-hook={DataHooks.title}>{title}</span>
          )}

          {subtitle && isString(subtitle) ? (
            <Text dataHook={DataHooks.subtitle} children={subtitle} secondary />
          ) : (
            <span data-hook={DataHooks.subtitle}>{subtitle}</span>
          )}
        </div>

        {suffix && (
          <div
            data-hook={DataHooks.suffix}
            className={classes.suffix}
            children={suffix}
          />
        )}
      </div>
    );
  }
}

export default Header;
